exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.text-error {\n  min-height: 0.16rem !important;\n  line-height: 0.16rem !important;\n}\n#login .account-form .form-row.btn-wrap {\n  margin-top: 0rem !important;\n}\n#login .account-form .form-row.btn-wrap .text-error {\n  text-align: center;\n  line-height: 0.44rem !important;\n}\n#login .account-form .form-row.btn-wrap .text-error.lang {\n  line-height: 0.18rem !important;\n  margin-bottom: 0.08rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-623f25a6","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/personalCenter/resetPwd.vue
// module id = 147
// module chunks = 1 2